module.exports = __webpack_public_path__ + "img/2大廳.e6e21a5c.jpg";